import React from "react";
import { Accordion, AccordionItem, Container, Heading } from "toddlar-ui";

const items = [
  {
    title: "More for your money",
    body: "Borrow toys worth at least 4× more than the price of your subscription.",
  },
  {
    title: "Good for the planet",
    body: "Divert toys from landfill when you swap instead of shop.",
  },
  {
    title: "Goodbye toy clutter",
    body: "Keep your home tidy by rotating toys instead of stockpiling them.",
  },
  {
    title: "Spoilt for choice",
    body: "Discover a wide range of toys, curated and quality-checked.",
  },
  {
    title: "It's hassle-free",
    body: "Simple ordering and fast delivery right to your door.",
  },
  {
    title: "All taken care of",
    body: "Cleaning and checks between every order for peace of mind.",
  },
];

const WhyUseUs: React.FC = () => {
  return (
    <div className="bg-sand-50">
      <Container>
        <Heading size="h2" className="text-center mb-6">
          Why use Toddla?
        </Heading>
        <Accordion className="w-full" multiple>
          {items.map((it, idx) => (
            <AccordionItem key={idx} title={it.title} defaultOpen={idx === 1}>
              {it.body}
            </AccordionItem>
          ))}
        </Accordion>
      </Container>
    </div>
  );
};

export default WhyUseUs;
